import { render } from "./packhome.vue?vue&type=template&id=6b14dd14&scoped=true"
import script from "./packhome.vue?vue&type=script&lang=js"
export * from "./packhome.vue?vue&type=script&lang=js"

import "./packhome.vue?vue&type=style&index=0&id=6b14dd14&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b14dd14"]])

export default __exports__